import React from 'react'

import PersonalCard from './card'

import Navigation from '../navigation/navigation'
import { consumerservice } from "../service/consumer.service";

import { Button, ButtonToolbar } from 'react-bootstrap'
import { util } from "../service/util";
import { wechatservice } from "../service/wechat.service";
import { env } from "../../platform/env";
import { navigate_to } from "../../platform/navigate";

const person_info_area = {
    width: `100%`,
    height: `100%`,
    backgroundColor: `#f2f2f2`
}

const personal_info_item = {
    height: `4rem`,
    width: `85%`,
    margin: `3rem 7.5%`,
    textAlign: `left`
}

const tip_style = {
    width: `85%`,
    margin: `0 7.5%`,
    color: `#888`,
    fontSize: `1.3rem`,
    lineHeight: `1.6`
}

class Person extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            mobile: '',
            address: '',
            wechat: '',
            bind: false,
            appid: ''
        }
        this.init_config = this.init_config.bind(this);
        this.bind_wechat = this.bind_wechat.bind(this);
        this.unbind_wechat = this.unbind_wechat.bind(this);
    }

    init_config = () => {
        let url = window.location.href;
        if (!util.is_weixin()) {
            return;
        }
        wechatservice.configuration(url).then(response => {
            if (response.responseCode === 'RESPONSE_OK') {
                let result = response.data;
                window.wx.config({
                    beta: true,
                    debug: false,
                    appId: result.appId,
                    timestamp: result.timestamp,
                    nonceStr: result.nonceStr,
                    signature: result.signature,
                    jsApiList: ['hideAllNonBaseMenuItem']
                });
                this.setState({ appid: result.appId });
                window.wx.ready(() => {
                    window.wx.hideAllNonBaseMenuItem();
                });
            }
        });
    }

    componentDidMount() {
        if (util.is_weixin()) {
            util.load_script("https://res.wx.qq.com/open/js/jweixin-1.2.0.js", () => {
                this.init_config();
            })
        }
        consumerservice.profile().then(response => {
            if (response.responseCode === 'RESPONSE_OK') {
                let person = response.data;
                let address = (person.province == null ? '' : person.province) + (person.city == null ? '' : person.city) + (person.district === null ? '' : person.district);
                this.setState({ name: person.name, mobile: person.phone, address: address, wechat: person.wechat })
                if (new String(this.state.wechat) !== null && this.state.wechat !== '') {
                    this.setState({ bind: false })
                } else {
                    this.setState({ bind: true })
                }
            }
            if (response.responseCode === 'RESPONSE_ERROR') {
                navigate_to('/login');
                return;
            }
        }
        );
    }

    bind_wechat = () => {
        if (env.is_native()) {
            alert('请在微信内打开果麦智控页面完成微信绑定，以便接收微信模板消息。App 内提醒将通过系统推送发送。');
            return;
        }
        if (!util.is_weixin()) {
            alert('请使用微信打开本页面后再绑定微信');
            return;
        }
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.state.appid + "&redirect_uri=" + encodeURI('https://reception.gmair.net/wechat/bind') + "&response_type=code&scope=snsapi_base&state=gmair#wechat_redirect";
    }

    unbind_wechat = () => {
        consumerservice.unbind_wechat().then(response => {
            if (response.responseCode === 'RESPONSE_OK') {
                navigate_to('/personal/information')
            }
        })
    }

    render() {
        const showWechatBind = !env.is_native();
        return (
            <div style={person_info_area}>
                <PersonalCard />
                {env.is_native() ? (
                    <div style={tip_style}>
                        当前为 App 登录。滤网等提醒将通过系统推送送达；如仍需微信模板消息，请在微信内打开并绑定微信账号。
                    </div>
                ) : null}
                {showWechatBind ? (
                    <div style={personal_info_item}>
                        <ButtonToolbar>
                            <Button type="primary" bsStyle={this.state.bind === true ? "success" : "danger"} block
                                onClick={this.state.bind === true ? this.bind_wechat : this.unbind_wechat}>
                                {this.state.bind === true ? "绑定微信" : "解绑微信"}
                            </Button>
                        </ButtonToolbar>
                    </div>
                ) : null}
                <Navigation index={1} />
            </div>
        )
    }
}

export default Person;
